<template>
  <v-card>
    <v-toolbar flat>
      <span class="headline">Deny Confirmation</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="hideDialog">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-layout row class="deny-tips" v-if="loanScore >= 5">
      <v-flex lg12>
        <div class="deny-content">
          This Loan has low credit risk per Pre-Application Review. Do you really want to deny it? Please select the category below:
        </div>
      </v-flex>
    </v-layout>
    <v-layout row class="withdrawn-reason">
      <v-radio-group
        v-model="withdrawnCode"
      >
        <vue-perfect-scrollbar class="reason-radio-group">
          <v-radio
            v-for="(option, j) in WithdrawnReason"
            color="primary"
            :label="option.text"
            :value="option.value"
            :key="j"
            class="reason-text"
          ></v-radio>
        </vue-perfect-scrollbar>
      </v-radio-group>
    </v-layout>
    <v-layout row style="width: 500px">
      <v-flex lg12 class="deny-bord">
        <v-textarea
          class="deny-notes"
          auto-grow
          name="notes"
          label="Notes"
          v-model="notes"
          hide-details
          shaped
          rows="4"
          row-height="30"
        ></v-textarea>
      </v-flex>
    </v-layout>
    <v-card-actions class="pb-3" style="margin-top: 10px">
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="saveNote">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { Tool, DataType } from '@/util/index'
const tool = new Tool()

export default {
  name: 'tribe-deny-dialog',
  props: {
    loanScore: Number
  },
  data () {
    return {
      valid: true,
      status: DataType.LoanStatus,
      WithdrawnReason: DataType.TribeDeny,
      withdrawnCode: [],
      notes: '',
      tool: tool
    }
  },
  methods: {
    saveNote () {
      if (tool.isEmpty(this.notes)) {
        this.$swal({ type: 'warning', text: 'Please add note content', showCancelButton: false })
      } else if (tool.isEmpty(this.withdrawnCode)) {
        this.$swal({ type: 'warning', text: 'Please select the reason of withdrawn', showCancelButton: false })
      } else {
        const targetStatus = this.status.NEGATIVE_WITHDRAWN.value
        this.$emit('updateLoanStatusAndAddNote', { targetStatus: targetStatus, note: this.notes, reasonCode: this.withdrawnCode })
        this.hideDialog()
      }
    },
    hideDialog () {
      this.$emit('hideDialog', 'TRIBE_DENY')
    }
  }
}
</script>
<style lang="css" scoped>
  .withdrawn-reason {
    margin: 0 5px 10px 25px;
    width: 530px;
    height: 80px;
  }
  .reason-radio-group {
    height: 90px;
  }
  .reason-text {
    margin: 5px 0 auto 10px;
    height: 30px;
  }
  .deny-tips {
    margin-top: 0;
    width: 550px;
    margin-left: 10px;
  }
  .deny-content {
    width: 500px;
    margin-left: 25px;
    font-size: 16px;
  }
  .deny-bord{
    margin-top: 15px;
  }
  .deny-notes{
    width: 500px;
    margin: auto 10px auto 50px;
  }
</style>
